<template>
    <div>
        <!-- modal -->
        <b-modal id="ownersFormModal" ref="ownersFormModal" centered size="xl" no-close-on-backdrop :title=" $t('owners.info')" hide-footer>
            <reminder-form ref="reminderForm"></reminder-form>
            <b-card>
                <validation-observer ref="simpleRules">
                    <!-- 1. Satır: Vekaletname Bitiş Tarihi (sol) + Kaydet/Yazdır/Hatırlatma ikonları (sağ) -->
                    <b-row class="align-items-end">
                        <b-col md="6" :hidden="isOwner == false">
                            <label for="owners-power-of-attorney-deadline-date-input">{{ $t('owners.power_of_attorney_deadline_date') }}</label>
                            <b-form-group class="mb-0">
                                <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" :placeholder="$t('owners.power_of_attorney_deadline_date')" size="sm" v-model="powerOfAttorneyDeadlineDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                            </b-form-group>
                        </b-col>
                        <b-col class="d-flex justify-content-end align-items-center ml-auto">
                            <b-button v-if="this.id != 0" variant="outline-primary" size="sm" class="mr-1" @click.prevent="ownersConflictCheck">
                                {{$t('others.ok_title')}}
                            </b-button>
                            <b-dropdown v-if="this.id != 0" style="width: 4em; height: 2em;" id="dropdown-grouped" variant="outline-primary" right class="dropdown-icon-wrapper" size="sm">
                                <template #button-content>
                                    <feather-icon icon="PrinterIcon" size="10" class="align-middle" />
                                </template>
                                <b-dropdown-item @click="downloadClientWordFile(wordTemplate.id, wordTemplate.name)" v-for="wordTemplate in wordTemplateList" :key="wordTemplate.id">
                                    <span>{{wordTemplate.name}}</span>
                                </b-dropdown-item>
                            </b-dropdown>
                            <b-button v-if="this.id != 0" variant="outline-primary" class="ml-1" size="sm" v-b-tooltip.html :title="$t('others.reminder')" @click="getReminderInfo()">
                                <feather-icon icon="BellIcon" size="10" class="align-middle" />
                            </b-button>
                        </b-col>
                    </b-row>
                    <!-- 2. Satır: Sahip Adı | Sahip Kodu | Sektör (salt-okunur, WS'den) -->
                    <b-row class="mt-1">
                        <b-col md="4">
                            <label for="owners-name-input">{{ $t('owners.name') }}</label>
                            <b-form-group>
                                <validation-provider #default="{ errors }" :name=" $t('owners.name')" rules="required">
                                    <b-form-input disabled size="sm" id="owners-name-input" v-model="name" maxlength="250" :state="errors.length > 0 ? false:null" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <label for="owners-owner-code-input">{{ $t('owners.owner_code') }}</label>
                            <b-form-group>
                                <cleave disabled style="height: 2em;" id="owners-owner-code-input" v-model="ownerCode" class="form-control" :raw="false" :options="ownerCodeOptions" placeholder="000000" />
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <label for="owners-sector-input">{{ $t('owners.sector') }}</label>
                            <b-form-group>
                                <b-form-input disabled size="sm" id="owners-sector-input" :value="sectorDisplay" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <!-- 3. Satır: Adres -->
                    <b-row class="mt-1">
                        <b-col>
                            <label for="owners-address-input">{{ $t('owners.address') }}</label>
                            <b-form-textarea disabled id="owners-address-input" :placeholder=" $t('owners.address')" size="sm" rows="3" v-model="address" />
                        </b-col>
                    </b-row>
                    <!-- 4. Satır: Ülke -->
                    <b-row class="mt-1">
                        <b-col class="col-lg-12">
                            <label for="owners-country-input">{{ $t('owners.country') }}</label>
                            <b-form-select id="owners-country-input" disabled :placeholder="$t('owners.country')" size="sm" v-model="countrySelect" value-field="id" text-field="name" :options="countryOption" />
                        </b-col>
                    </b-row>
                </validation-observer>
            </b-card>
            <b-card :hidden="hiddenClientControl">
                <b-row>
                    <b-col class="mt-2">
                        <b-tabs pills vertical nav-wrapper-class="nav-vertical">
                            <!-- <b-tab :title=" $t('owners.accounting')" style="width:100%;">
                                <b-card-text>
                                    <clients-accounting-list :clientId="this.clientId" ref="clientAccountingList"></clients-accounting-list>
                                </b-card-text>
                            </b-tab> -->
                             <b-tab :title=" $t('clientsAccounting.note')" style="width:100%;">
                                <b-card-text>
                                    <client-note-list :clientId="this.clientId" ref="clientNoteList" :getOwnersList="getOwnersList"></client-note-list>
                                </b-card-text>
                            </b-tab>
                            <b-tab :title="$t('matter.matter_document')" style="width:100%;">
                                <b-card-text>
                                    <matter-document-list :recordId="this.id" :moduleId="1" :getOwnersList="getOwnersList"></matter-document-list>
                                </b-card-text>
                            </b-tab>
                            <!-- <b-tab :title="$t('owners.invoices')" style="width:100%;">
                                <b-card-text>
                                    <client-invoice-list :lawClientId="this.id" ref="clientInvoiceList" :getOwnersList="getOwnersList"></client-invoice-list>
                                </b-card-text>
                            </b-tab> -->
                            <b-tab :title="$t('owners.invoice_codes')" style="width:100%;">
                                <b-card-text>
                                    <clients-invoice-code-list :lawClientId="this.id" ref="clientsInvoiceCodeList" :getOwnersList="getOwnersList"></clients-invoice-code-list>
                                </b-card-text>
                            </b-tab>
                            <!-- <b-tab :title="$t('owners.responsible')" style="width:100%;">
                                <b-card-text>
                                    <client-responsible-list :clientId="this.clientId" ref="clientResponsibleList" :getOwnersList="getOwnersList"></client-responsible-list>
                                </b-card-text>
                            </b-tab>
                            <b-tab :title="$t('owners.contact')" style="width:100%;">
                                <b-card-text>
                                    <client-contact-list :clientId="this.clientId" ref="clientContactList" :getOwnersList="getOwnersList"></client-contact-list>
                                </b-card-text>
                            </b-tab> -->
                            <!-- <b-tab :title="$t('owners.ledes_files')" style="width:100%;">
                                <b-card-text>
                                    <law-client-accounting-ledes-list :clientId="this.clientId" ref="lawClientAccountingLedesList" :getOwnersList="getOwnersList"></law-client-accounting-ledes-list>
                                </b-card-text>
                            </b-tab> -->
                        </b-tabs>
                    </b-col>
                </b-row>
            </b-card>
        </b-modal>
    </div>
    </template>
    
    <script>
    export default {
        props: {
            getOwnersList: {
                type: Function
            }
        },
        data() {
            return {
                id: 0,
                clientId: 0,
                name: '',
                ownerCode: null,
                ownerCodeOptions: {
                    blocks: [6],
                    numericOnly: true
                },
                wordTemplateList: [],
                mailTemplateList: [],
                isOwner: false,
                isAgent: false,
                working: false,
                annuity: false,
                compensationFee: false,
                patentCertificate: false,
                address: '',
                contact: '',
                responsible: '',
                powerOfAttorneyDeadlineDate: null,
                hiddenClientControl: true,
                countrySelect: 0,
                countryOption: [],
                // STOCK-2875 Faz 7: Sektör (WS'den, salt-okunur). Sector entity çift dilli.
                sectorNameTR: '',
                sectorNameEN: '',
            }
        },
        computed: {
            state() {
                return this.isAgent || this.isOwner
            },
            // Aktif dile göre sektör adı; veri yoksa boş.
            sectorDisplay() {
                return (this.$i18n.locale === 'en' ? this.sectorNameEN : this.sectorNameTR) || ''
            },
        },
        methods: {
            async getReminderInfo() {
                this.$refs.reminderForm.showInfo(0, this.id, 1)
            },
            showInfo(id, clientId) {
                this.$refs['ownersFormModal'].show()
                this.id = id
                this.clientId = clientId
                if (this.id == 0) {
                    this.hiddenClientControl = true
                } else {
                    this.hiddenClientControl = false
                }
                const data = {
                    id: this.id
                }
                const controller = {
                    name: 'LawClient'
                }
                const payload = {
                    data: data,
                    controller: controller
                }
                this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                    if (response.data.resultStatus == true) {
                        this.clientId = response.data.lawClient.clientId
                        this.wordTemplateList = response.data.wordTemplateList
                        this.mailTemplateList = response.data.mailTemplateList
                        this.name = response.data.lawClient.client
                        this.isAgent = response.data.lawClient.isAgent
                        this.isOwner = response.data.lawClient.isOwner
                        this.ownerCode = response.data.lawClient.code
                        this.address = response.data.lawClient.clientAddress
                        this.contact = response.data.lawClient.clientContact
                        this.responsible = response.data.lawClient.clientResponsible
                        this.powerOfAttorneyDeadlineDate = response.data.lawClient.powerOfAttorneyDeadlineDate
                        this.sectorNameTR = response.data.lawClient.sectorNameTR
                        this.sectorNameEN = response.data.lawClient.sectorNameEN
                        this.countryOption = response.data.countryList
                        this.countryOption.splice(0, 0, this.$nullSelected())
                        if (response.data.lawClient.countryId > 0) {
                            this.countrySelect = response.data.lawClient.countryId
                        }
                        //this.$refs.documentList.getMatterDocumentList()
                        //Close 15.07.2025 Asenkron çalışıyot. sayfa geliyor sonra sonuçlar geliyor ama sayfa açıldığında tablo boş görünüyor. 
                        //Stocktaki yapıya döndük
                        // changelog: Clients list already have clientId inside of it so thats why i send the id,
                        //  and InvoiceCode list , Accountings list call again isnt neccesary right now.
                        //Nevzat 12.02.2025
                    } else {
                        this.$bvModal.hide('ownersFormModal')
                        this.$WarningAlert(response.data.resultMessage)
                    }
                })
            },
            downloadClientWordFile(documentId, name) {
                const data = {
                    moduleId: 1,
                    documentId: documentId,
                    clientId: this.clientId
                }
                const controller = {
                    name: 'Client',
                    actionName: 'DownloadClientWordFile'
                }
                const payload = {
                    data: data,
                    controller: controller
                }
                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                    if (response.data.resultStatus == true) {
                        this.$downloadFile(name + '-' + this.name, response.data.base64, 'docx')
                    } else {
                        this.$WarningAlert(response.data.resultMessage)
                    }
                })
            },
            ownersConflictCheck() {
                if (this.id > 0) {
                    this.addOrUpdate()
                } else {
                    this.$refs.simpleRules.validate().then(success => {
                        if (this.isAgent == true || this.isOwner == true) {
                            if (success) {
                                const data = {
                                    string: this.name
                                }
                                const controller = {
                                    name: 'ClientConflict',
                                    actionName: 'GetClientConflictListByClientName'
                                }
                                const payload = {
                                    data: data,
                                    controller: controller
                                }
                                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                                    if (response.data.clientConflictList.length > 0) {
                                        // Müvekkil Çıkar Çatışması için kontrol içine mesaj basılması gerekiyor bunu nasıl yapacağımızı konuşmalıyız . 
                                        this.$ClientConflictControl(response.data.resultMessage).then(result => {
                                            if (result.value) {
                                                this.addOrUpdate()
                                            }
                                        })
                                    } else {
                                        this.addOrUpdate()
                                    }
                                })
                                if (this.id == 0) {
                                    this.id = response.data.clientId
                                    this.hiddenClientControl = false
                                }
                            }
                        } else {
                            this.$isOwnerOrAgent()
                        }
                    })
                }
    
            },
            addOrUpdate() {
                const data = {
                    id: this.id,
                    name: this.name,
                    isAgent: this.isAgent,
                    isOwner: this.isOwner,
                    ownerCode: this.ownerCode,
                    powerOfAttorneyDeadlineDate: this.powerOfAttorneyDeadlineDate
                }
                const controller = {
                    name: 'LawClient'
                }
                const payload = {
                    data: data,
                    controller: controller
                }
                this.$refs.simpleRules.validate().then(success => {
                    if (this.isAgent == true || this.isOwner == true) {
                        if (success) {
                            this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                                if (response.data.resultStatus == true) {
                                    this.$bvModal.hide('ownersFormModal')
                                    this.getOwnersList()
                                    this.$SaveAlert()
                                } else {
                                    this.$WarningAlert(response.data.resultMessage)
                                }
                            })
                        }
                    } else {
                        this.$isOwnerOrAgent()
                    }
                })
            },
        }
    }
    </script>
    
    <style lang="scss">
    [dir=ltr] .modal-header .close {
        margin: -0.4rem -0.4rem -0.8rem auto;
    }
    
    [dir] label {
        margin-bottom: 0.2857rem;
        font-weight: bold;
    }
    
    .modal .modal-content {
        overflow: visible;
        margin-bottom: auto;
    }
    
    [dir] .invalid-tooltip {
        padding: 0.4rem 0.775rem !important;
        margin-top: -1.5rem !important;
        background-color: #ea5455 !important;
        border-radius: 0.358rem !important;
        left: 20px !important
    }
    
    [dir] .dark-layout .modal .modal-content,
    [dir] .dark-layout .modal .modal-body,
    [dir] .dark-layout .modal .modal-footer {
        background-color: #272e3f !important;
        border-color: #3b4253;
    }
    
    [dir] .vs__selected-options {
        padding: 0 2px;
        font-size: 0.9em;
    }
    </style>
    